import { Target, Eye, Award, Users, GraduationCap, Building2 } from 'lucide-react';

const About = () => {
  return (
    <div className="pt-20" data-testid="about-page">
      <section
        className="relative min-h-[70vh] flex items-center justify-center"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/l4i7elt4_WhatsApp%20Image%202026-06-04%20at%209.29.02%20PM.jpeg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-black/80"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-500 mb-4">WHO WE ARE</p>
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter uppercase mb-6" style={{ fontFamily: 'Open Sans' }}>ABOUT KAROBAR</h1>
          <p className="text-gray-300 text-lg leading-relaxed">The official entrepreneurship club of Christ University, Bangalore - fostering innovation, building startups, and creating the leaders of tomorrow.</p>
        </div>
      </section>

      <section className="section-padding bg-gradient-to-b from-black to-[#121212]">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
            <div>
              <img
                src="https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/mtoz0sqh_image.png"
                alt="Christ University"
                className="w-full max-w-md mx-auto"
              />
            </div>
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <GraduationCap className="text-gold-500" size={40} />
                <h2 className="text-4xl font-black" style={{ fontFamily: 'Open Sans' }}>CHRIST UNIVERSITY</h2>
              </div>
              <p className="text-gray-400 text-lg leading-relaxed mb-4">
                Christ University, established in 1969, is a multi-disciplinary institution of higher learning located in Bangalore, India. Deemed to be University in 2008, it has consistently been ranked among the top universities in India for its academic excellence, innovative teaching methodologies, and holistic development approach.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed">
                With a motto of "Excellence and Service," Christ University nurtures students to become responsible global citizens who contribute meaningfully to society while excelling in their chosen fields.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
            <div className="order-2 lg:order-1">
              <div className="flex items-center space-x-3 mb-6">
                <Building2 className="text-gold-500" size={40} />
                <h2 className="text-4xl font-black" style={{ fontFamily: 'Open Sans' }}>DEPARTMENT OF PROFESSIONAL STUDIES</h2>
              </div>
              <p className="text-gray-400 text-lg leading-relaxed mb-4">
                The Department of Professional Studies (DPS) at Christ University is dedicated to providing industry-relevant, skill-based education that prepares students for the dynamic professional world. DPS offers programs that bridge the gap between academic learning and practical application.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed mb-4">
                With a focus on entrepreneurship, innovation, and leadership development, DPS creates an ecosystem where students can explore their potential, develop critical thinking skills, and build ventures that make a real-world impact.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed">
                Through initiatives like KAROBAR, DPS empowers students to transform their ideas into successful enterprises while fostering a culture of innovation and creativity.
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img
                src="https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/gwf6d0sh_image.png"
                alt="Department of Professional Studies"
                className="w-full max-w-md mx-auto"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <Target className="text-gold-500" size={40} />
                <h2 className="text-4xl font-black" style={{ fontFamily: 'Open Sans' }}>OUR MISSION</h2>
              </div>
              <p className="text-gray-400 text-lg leading-relaxed">
                To create a vibrant ecosystem where student entrepreneurs can transform their ideas into impactful ventures. We provide mentorship, resources, and a supportive community to help aspiring business leaders navigate their entrepreneurial journey.
              </p>
            </div>
            <div className="glass-card p-12 relative overflow-hidden group">
              <div className="absolute inset-0 bg-gradient-to-br from-gold-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative z-10">
                <h3 className="text-2xl font-black mb-4 text-gold-500" style={{ fontFamily: 'Open Sans' }}>WHAT WE DO</h3>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start space-x-3">
                    <span className="text-gold-500 mt-1">•</span>
                    <span>Organize workshops, pitch competitions, and networking events</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold-500 mt-1">•</span>
                    <span>Connect students with industry mentors and investors</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold-500 mt-1">•</span>
                    <span>Provide resources and guidance for startup development</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-gold-500 mt-1">•</span>
                    <span>Build a community of like-minded innovators and leaders</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="glass-card p-12 order-2 lg:order-1">
              <div className="flex items-center space-x-3 mb-6">
                <Eye className="text-gold-500" size={40} />
                <h2 className="text-4xl font-black" style={{ fontFamily: 'Open Sans' }}>OUR VISION</h2>
              </div>
              <p className="text-gray-300 text-lg leading-relaxed">
                To be recognized as India's leading student entrepreneurship community, producing successful founders who create lasting impact through innovation and sustainable business practices.
              </p>
            </div>
            <div className="order-1 lg:order-2 flex items-center justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_bf190b2c-0547-4061-a149-b09b814092c5/artifacts/xou2tw75_Screenshot%202026-05-07%20075825.png"
                alt="KAROBAR Logo"
                className="w-full max-w-sm mx-auto"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding bg-[#121212]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>WHY JOIN KAROBAR?</h2>
            <p className="text-gray-400 text-lg">Be part of something extraordinary</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card p-8 text-center hover:scale-105 transition-transform" data-testid="benefit-card-1">
              <Users className="w-16 h-16 text-gold-500 mx-auto mb-6" />
              <h3 className="text-xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>NETWORK</h3>
              <p className="text-gray-400 leading-relaxed">Connect with 100+ aspiring entrepreneurs, mentors, and industry leaders.</p>
            </div>
            <div className="glass-card p-8 text-center hover:scale-105 transition-transform" data-testid="benefit-card-2">
              <Award className="w-16 h-16 text-gold-500 mx-auto mb-6" />
              <h3 className="text-xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>LEARN</h3>
              <p className="text-gray-400 leading-relaxed">Access exclusive workshops, masterclasses, and resources to build your skills.</p>
            </div>
            <div className="glass-card p-8 text-center hover:scale-105 transition-transform" data-testid="benefit-card-3">
              <Target className="w-16 h-16 text-gold-500 mx-auto mb-6" />
              <h3 className="text-xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>GROW</h3>
              <p className="text-gray-400 leading-relaxed">Turn your ideas into reality with mentorship and support from experienced founders.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
